import { createInterpolatedTranslationKey } from '@dreryk/react-common';
import { Notification, NotificationSize, NotificationType } from '@dreryk/react-components';

import { sentPrescriptionPackagesTranslationKeys } from '../../../../translations';

import { PrescriptionPackageAccessCode } from './SentPrescriptionPackagesList.types';

type PrescriptionPackageAccessCodeNotificationProps = {
   readonly accessCode: PrescriptionPackageAccessCode | undefined;
};

export const PrescriptionPackageAccessCodeNotification = (
   props: PrescriptionPackageAccessCodeNotificationProps
): JSX.Element => {
   const { accessCode } = props;
   const label = accessCode
      ? createInterpolatedTranslationKey(sentPrescriptionPackagesTranslationKeys.prescriptionIssuedWithAccessCode, {
           accessCode: accessCode,
        })
      : sentPrescriptionPackagesTranslationKeys.prescriptionIssuedWithoutAccessCode;

   return (
      <Notification
         type={NotificationType.SUCCESS}
         label={label}
         size={NotificationSize.SMALLER}
         testId={'prescriptionPackageIssued'}
      />
   );
};
